import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './breadcrumb.component';
import { ButtonModule as MatButtonModule } from '@shared/material/button';
import { RouterModule } from '@angular/router';
import { SharedComponentsModule } from '@shared/components';

@NgModule({
  imports: [CommonModule, MatButtonModule, RouterModule, SharedComponentsModule],
  declarations: [BreadcrumbComponent],
  exports: [BreadcrumbComponent],
})
export class BreadcrumbModule {}
